import TIM from 'tim-js-sdk/tim-js-friendship'
import TIMUploadPlugin from 'tim-upload-plugin'

const tim = TIM.create({
    SDKAppID: parseInt(process.env.VUE_APP_APPID)
})

window.setLogLevel = tim.setLogLevel

// 无日志级别-生产环境开启
tim.setLogLevel(4)
//有日志级别
// tim.setLogLevel(1)

// 注册 cos
tim.registerPlugin({ 'tim-upload-plugin':TIMUploadPlugin })
export default tim
